import React from "react";

const Footer = () => {
  return (
    <>
      {/* Main Footer Content */}
      <footer className="footer p-10 bg-black text-gray-500">
        <nav>
          <header className="footer-title">Insurance</header>
          <a
            href="https://insurancecart.ae/health-insurance"
            className="link link-hover"
          >
            Health Insurance
          </a>
          <a
            href="https://insurancecart.ae/travel-insurance"
            className="link link-hover"
          >
            Travel Insurance
          </a>
          <a
            href="https://insurancecart.ae/business-insurance"
            className="link link-hover"
          >
            Business Insurance
          </a>
          <a
            href="https://insurancecart.ae/cheap-car-automobile-quotes"
            className="link link-hover"
          >
            Car Insurance
          </a>
        </nav>
        <nav>
          <header className="footer-title">Other</header>
          <a
            href="https://insurancecart.ae/house-insurance"
            className="link link-hover"
          >
            House Insurance
          </a>
          <a
            href="https://insurancecart.ae/compare-life-insurance"
            className="link link-hover"
          >
            Life Insurance
          </a>
          <a
            href="https://insurancecart.ae/contact"
            className="link link-hover"
          >
            Contact
          </a>
          <a href="https://insurancecart.ae/" className="link link-hover">
            Home
          </a>
        </nav>
        <nav>
          <header className="footer-title">Legal</header>
          <a className="link link-hover">Terms of use</a>
          <a className="link link-hover">Privacy policy</a>
          <a className="link link-hover">Cookie policy</a>
        </nav>
      </footer>

      {/* Footer Bottom Content */}
      <footer className="bg-black">
        <div className="max-w-7xl mx-auto px-3 md:px-7 lg:px-2 py-4">
          <img src="image/footer-img.jpg" alt="Footer Image" />
          <div className="text-gray-400 flex justify-between items-center mt-8">
            <p>© Copyright 2008-2025, All Rights Reserved.</p>
            <div className="flex gap-8 text-2xl">
              <i className="fa-brands fa-facebook-f"></i>
              <i className="fa-brands fa-x-twitter"></i>
              <i className="fa-brands fa-linkedin-in"></i>
              <i className="fa-brands fa-youtube"></i>
            </div>
          </div>
        </div>
      </footer>
    </>
  );
};

export default Footer;
